import React, { useContext } from 'react';
import crackCloud from "assets/crack-cloud.svg";
import crackRedTemp from "assets/crack-red-temp.svg";
import crackYellowTemp from "assets/crack-yellow-temp.svg";
import crackUpArrow from "assets/crack-uparrow.svg";
import crackDownYellowArrow from "assets/crack-yellow-arrow.svg";
import { ModalContext } from 'hooks/ModalProvider';
import classNames from 'utilities/ClassNames';

interface AnalyticalBoxProps {
    label: string;
}

const AnalyticalBox: React.FC<AnalyticalBoxProps> = ({ label }) => {
    const { setCracModalShown } = useContext(ModalContext);
    return (
        <>
            <div className={classNames(label === 'Crac-5' ? "bg-red/30 border-red" : "bg-black/35 border-black", "p-1 max-h-[50px] w-fit rounded-md hover:bg-gray-100 cursor-pointer flex gap-1 border-2")}
                onClick={() => setCracModalShown(true)}
            >
                <div className=" p-1 flex items-center justify-center w-[55px]">
                    <h3 className="text-[14px] text-center font-[700]">{label}</h3>
                </div>
                <div className={classNames(label === 'Crac-5' ? "bg-red/30 border-red" : "bg-black border-black", "border-2 rounded-md p-1 py-2 flex items-center flex-col gap-1 justify-center w-[50px]")}>
                    <img src={crackCloud} alt="" className='w-[10px]' />
                    <h3 className="text-[10px] text-center font-medium">78%</h3>
                </div>
                <div className={classNames(label === 'Crac-5' ? "bg-red/30 border-red" : "bg-black border-black", "border-2 rounded-md p-1 py-2 flex items-center flex-col gap-1 justify-center w-[50px]")}>
                    <div className="flex justify-center ">
                        <img src={crackUpArrow} alt="" className='w-[8px]' />
                        <img src={crackRedTemp} alt="" className='w-[10px]' />
                    </div>
                    <h3 className="text-[10px] text-center font-medium">28.9C</h3>
                </div>
                <div className={classNames(label === 'Crac-5' ? "bg-red/30 border-red" : "bg-black border-black", "border-2 rounded-md p-1 py-2 flex items-center flex-col gap-1 justify-center w-[50px]")}>
                    <div className="flex justify-center gap-1">
                        <img src={crackDownYellowArrow} alt="" className='w-[8px]' />
                        <img src={crackYellowTemp} alt="" className='w-[7px]' />
                    </div>
                    <h3 className="text-[10px] text-center font-medium">28.9C</h3>
                </div>
            </div>
        </>
    );
};

export default AnalyticalBox;